import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { GroupValidationService } from '../../layout/group-validation/group-validation.service';

@Component({
	selector: 'ae-submit-button',
	templateUrl: './submit-button.component.html',
	styleUrl: './submit-button.component.scss',
})
export class SubmitButtonComponent {
	@Input({ required: true }) form: AbstractControl;
	@Input() disabled: boolean = false;
	@Input() btnClass: string = 'btn btn-primary';

	@Output() save: EventEmitter<void> = new EventEmitter<void>();

	constructor(private groupValidationService: GroupValidationService) {}

	public onClick = () => {
		if (this.form?.valid && !this.disabled) {
			this.groupValidationService.forceShowState = false;
			this.save.emit();
		} else {
			this.groupValidationService.forceShowState = true;
			this.scrollToFirstInvalidControl();
		}
	};

	private scrollToFirstInvalidControl = () => {
		const firstInvalidControl = document.querySelector(
			'.ng-invalid',
		) as HTMLElement;

		if (firstInvalidControl) {
			firstInvalidControl.scrollIntoView({
				behavior: 'smooth',
				block: 'center',
			});
			firstInvalidControl.focus();
		}
	};
}
